import { useEffect, useState } from 'react';
import { fetchEventMemberModalData } from './memberModalApiUtils';

const EMPTY_ARRAY = [];

const toArray = (value) => (Array.isArray(value) ? value : EMPTY_ARRAY);

export default function useEventMemberModalData({
  open = false,
  enabled = true,
  apiUrl = '',
  eventId = '',
  participantsUrl = '',
  includeCastingInfo = true,
  includeCastingProgress = true,
  partsList = null,
  resetOnDisable = false,
  resetOnClose = false,
  errorLabel = 'member list fetch error',
}) {
  const [loading, setLoading] = useState(false);
  const [participantSnapshot, setParticipantSnapshot] = useState(null);
  const [parts, setParts] = useState(() => toArray(partsList));
  const [castingInfo, setCastingInfo] = useState([]);
  const [progress, setProgress] = useState([]);

  useEffect(() => {
    if (Array.isArray(partsList) && partsList.length > 0) {
      setParts(partsList);
    }
  }, [partsList]);

  useEffect(() => {
    const shouldReset = (!enabled && resetOnDisable) || (!open && resetOnClose);
    if (shouldReset) {
      setParticipantSnapshot(null);
      setCastingInfo([]);
      setProgress([]);
    }

    if (!open || !enabled || !apiUrl || !eventId || !participantsUrl) {
      if (!open || !enabled) {
        setLoading(false);
      }
      return undefined;
    }

    let active = true;
    (async () => {
      setLoading(true);
      try {
        const {
          participantSnapshot: nextParticipantSnapshot,
          parts: nextParts,
          castingInfo: nextCastingInfo,
          progress: nextProgress,
        } = await fetchEventMemberModalData({
          apiUrl,
          eventId,
          participantsUrl,
          includeCastingInfo,
          includeCastingProgress,
          partsList,
        });
        if (!active) return;
        setParticipantSnapshot(nextParticipantSnapshot);
        setParts(nextParts);
        setCastingInfo(nextCastingInfo);
        setProgress(nextProgress);
      } catch (error) {
        console.error(`${errorLabel}:`, error);
        if (!active) return;
        setParticipantSnapshot(null);
        setCastingInfo([]);
        setProgress([]);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [
    apiUrl,
    enabled,
    errorLabel,
    eventId,
    includeCastingInfo,
    includeCastingProgress,
    open,
    participantsUrl,
    partsList,
    resetOnClose,
    resetOnDisable,
  ]);

  return {
    loading,
    participantSnapshot,
    parts,
    castingInfo,
    progress,
    setParts,
    setParticipantSnapshot,
    setCastingInfo,
    setProgress,
  };
}
